import styled from '@emotion/styled';
import cx from 'classnames';
import Link from 'next/link';
import {removeInvalidTags} from 'utils/blog';

const colorsByTag = {
  go: '#82CFE4',
  performance: '#FE8B61',
};
const Bubble = styled.div`
  color: white;
  border-radius: 12px;
  padding: 0.25rem 1rem;
  font-size: 12px;
  margin-right: 0.5rem;
  white-space: nowrap;
`;

function getColorByTag(tag: string) {
  return colorsByTag[tag.toLowerCase()] || '#5263f1';
}

export const Tag = ({name, addLink = false}) => {
  return (
    <Bubble
      style={{backgroundColor: getColorByTag(name)}}
      className="mb-2.5 flex h-8 items-center justify-center capitalize "
    >
      {addLink ? (
        <Link
          href={`/blog/tags/${name.toLowerCase().replace(/\s+/g, '-') as string}`}
          className="text-xs text-white no-underline visited:text-white"
        >
          {name}
        </Link>
      ) : (
        <>{name}</>
      )}
    </Bubble>
  );
};

export const Tags = ({tags, centerOnMobile = false, isBlogPost = false}) => {
  const validTags = removeInvalidTags(tags);
  return (
    <div className={cx('flex flex-wrap lg:justify-start', {'justify-center': !!centerOnMobile})}>
      {validTags.map(tag => (
        <Tag addLink={isBlogPost} key={tag} name={tag} />
      ))}
    </div>
  );
};

export default Tags;
